import { render, staticRenderFns } from "./ShowCustomer.vue?vue&type=template&id=162b4e5e&scoped=true"
import script from "./ShowCustomer.vue?vue&type=script&lang=js"
export * from "./ShowCustomer.vue?vue&type=script&lang=js"
import style0 from "./ShowCustomer.vue?vue&type=style&index=0&id=162b4e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162b4e5e",
  null
  
)

export default component.exports